import dayjs from "dayjs";

const DATE_FORMAT = "DD MMM YYYY";

export const formatDate = (
    date: string | null | undefined,
    format = DATE_FORMAT
) => {
    if (date) {
        return dayjs(date).format(format);
    }
    return "--";
};

export default formatDate;
